import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSplit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"split"} maskId="square-outlined-radius-0-stroke-1-IconSplit"><path d="M12 2.5V21.5M8.5 4.5H2.5V19.5H8.5M15.5 19.5H21.5V4.5H15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
}));

export default IconSplit;
